/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：113
 */

module.exports = {
  flexSC: "DialCall_flexSC__3qv_X",
  dialCall: "DialCall_dialCall__1qdGM",
  deviceBox: "DialCall_deviceBox__30mek",
  callStatus: "DialCall_callStatus__1fqp5",
  noCallIcon: "DialCall_noCallIcon__3TSzG",
  phoneNumber: "DialCall_phoneNumber__3s-gR",
  callBtnBox: "DialCall_callBtnBox__uH-WX",
  callBtnItem: "DialCall_callBtnItem__215RM",
  callBtnText: "DialCall_callBtnText__3G0dO",
  active: "DialCall_active__R4zGQ",
  callEnd: "DialCall_callEnd__3o3U_",
  callConnect: "DialCall_callConnect__13z0B",
  receiveCall: "DialCall_receiveCall__3Alud",
  phoneNumberBox: "DialCall_phoneNumberBox__5CDLH",
  warning: "DialCall_warning__r9FS_",
  ReceiveSms: "DialCall_ReceiveSms__1dy5J",
  receiveSmsBtn: "DialCall_receiveSmsBtn__2hP6Y",
  disabled: "DialCall_disabled__2tgXm",
  textAreaWarning: "DialCall_textAreaWarning__2taUh"
}
